<template>
  <div class='WhatsBtn'>
    <whats-icon @click="Whats"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import WhatsIcon from './WhatsIcon'
export default {
  name: 'WhatsBtn',
  components: { WhatsIcon },
  computed: {
    ...mapGetters(['Empresa'])
  },
  methods: {
    Whats () {
      let msg = `Quero saber mais informações sobre um produto que vi no site. Pode me auxiliar?`
      window.location.replace(`https://wa.me/55${this.Empresa.whatsapp}?text=${msg}`)
    }
  }
}
</script>

<style scoped>
.WhatsBtn {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 2.5%;
  margin-bottom: 2%;
}
</style>
